import React, { useState } from "react";
import "./feedback.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function Feedback() {
  const [deleteProjectModel, setDeleteProjectModel] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedback] = useState([]);
  const [activeFeedback, setActiveFeedback] = useState({});
  const statusColors = {
    Resolved: "#28A745",
    Pending: "#868E96",
  };

  return (
    <>
      {feedback.length > 0 ? (
        <>
          <div className="project-container">
            <div className="first-row">
              <h2 className="heading">Customer Feedback</h2>
            </div>
            <div className="project-table-container">
              <table className="project-table">
                <thead>
                  <tr className="table-headings">
                    <th>Title</th>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {feedback.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.title}</td>
                      <td>{entry.email}</td>
                      <td>{entry.name}</td>
                      <td>{entry.date}</td>
                      <td>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: `${
                              statusColors[entry.status] ??
                              statusColors["Pending"]
                            }`,
                          }}
                        >
                          {entry.status}
                        </span>
                      </td>
                      <td style={{ minWidth: "100px" }}>
                        <span className="options-icon">
                          <div className="actions">
                            {/* View Feedback */}
                            <i
                              onClick={() => {
                                setActiveFeedback(entry);
                                setShowFeedback(true);
                              }}
                              className="bi bi-eye-fill"
                              style={{ color: "#27326A", padding: "8px" }}
                            ></i>
                            {/* Delete Feedback */}
                            <i
                              className="bi bi-trash-fill"
                              onClick={() => {
                                setActiveFeedback(entry);
                                setDeleteProjectModel(true);
                              }}
                              style={{ color: "#ff0000", padding: "8px" }}
                            ></i>
                          </div>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="project-container">
            <h2 className="heading">Customer Feedback</h2>
            <div className="noProject">
              <img
                src="./images/Logos/no_projects.svg"
                alt="No Feedback To Show"
              ></img>
              <h6>No Feedback To Show.</h6>
            </div>
          </div>
        </>
      )}

      {/* Delete Project Model */}
      <Modal
        show={deleteProjectModel}
        onHide={() => setDeleteProjectModel(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this feedback? <br />
          <br />
          <span style={{ color: "red", fontSize: "12px" }}>
            *All details will be lost and can not be recovered
          </span>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setDeleteProjectModel(false)}
          >
            Close
          </Button>
          <Button variant="primary" 
          // onClick={() => deleteFeedback()}
          >
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Feedback Model */}
      <Modal
        show={showFeedback}
        onHide={() => {
          setActiveFeedback({});
          setShowFeedback(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="featureModal"
      >
        <Modal.Body className="feature-show-model noBar">
          <div className="feedback-modal">
            <h4>{activeFeedback.title}</h4>
            <p>
              <strong>Name:</strong> {activeFeedback.name}
            </p>
            <p>
              <strong>Email:</strong> {activeFeedback.email}
            </p>
            <p>
              <strong>Role:</strong> {activeFeedback.role}
            </p>
            <p>
              <strong>Page:</strong> {activeFeedback.page}
            </p>
            {activeFeedback.projectId !== "N/A" && (
              <p>
                <strong>Project ID:</strong> {activeFeedback.projectId}
              </p>
            )}
            <p>
              <strong>Date:</strong> {activeFeedback.date}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              <span
                className="badge"
                style={{
                  backgroundColor: `${
                    statusColors[activeFeedback.status] ??
                    statusColors["Pending"]
                  }`,
                }}
              >
                {activeFeedback.status}
              </span>
            </p>
            <p style={{ marginTop: "10px" }}>
              <strong>Description:</strong> {activeFeedback.description}
            </p>
            {activeFeedback.fileType === "image" && (
              <img
                src={activeFeedback.fileURL}
                alt="Feedback Attachment"
                style={{ width: "100%", marginTop: "10px" }}
              />
            )}
            {activeFeedback.fileType === "video" && (
              <video
                src={activeFeedback.fileURL}
                alt="Feedback Attachment"
                style={{ width: "100%", marginTop: "10px" }}
                controls
              ></video>
            )}
          </div>

          <div className="button-pair">
            <button
              className="closeButton"
              onClick={() => {
                setActiveFeedback({});
                setShowFeedback(false);
              }}
            >
              Close
            </button>
            {/* If status is pending, show mark resolved button else show delete feedback button */}
            {activeFeedback.status !== "Resolved" ? (
              <button className="nextButton" 
              // onClick={(e) => markResolved()}
              >
                Mark Resolved
              </button>
            ) : (
              <button
                className="nextButton"
                onClick={() => {
                  setDeleteProjectModel(true);
                }}
              >
                Delete Feedback
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Feedback;
